import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 bg-stone-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-3xl font-bold text-green-900 mb-8">Privacy Policy</h1>
          <div className="bg-white rounded-xl border border-stone-200 p-8 space-y-6 text-stone-700 leading-relaxed">
            <p>Nark Online respects your privacy and is committed to protecting your personal information.</p>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Information We Collect</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Name, phone number, and address</li>
                <li>Order and transaction details</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">How We Use Information</h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>To process and deliver orders</li>
                <li>To communicate with customers</li>
                <li>To improve our services</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Sharing of Information</h2>
              <p>We may share necessary information with:</p>
              <ul className="list-disc pl-6 space-y-1 mt-1">
                <li>Delivery partners (e.g., Eersterust Tuk Tuk Association)</li>
                <li>Payment providers such as Paystack</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Data Protection</h2>
              <p>We take reasonable steps to protect your data.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-stone-900 mb-2">Your Rights</h2>
              <p>You may request access, correction, or deletion of your data.</p>
            </section>

            <section className="pt-4 border-t border-stone-200">
              <p className="text-sm text-stone-500">
                Contact: <a href="mailto:admin@narkonline.com" className="text-green-700 hover:underline">admin@narkonline.com</a>
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
